import { render, staticRenderFns } from "./BlockListImagesCustom.vue?vue&type=template&id=b955a2e4&"
import script from "./BlockListImagesCustom.vue?vue&type=script&lang=js&"
export * from "./BlockListImagesCustom.vue?vue&type=script&lang=js&"
import style0 from "./BlockListImagesCustom.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports